/* Stockporter label studio: live sheet preview, then add to cart with the
   customer's words saved as line-item properties (what prints = what they saw). */
(() => {
  if (window.__stockporterStudio) return;
  window.__stockporterStudio = true;
  const theme = window.theme || {};
  const esc = theme.esc || (s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])));
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = cents => (theme.money ? theme.money(cents) : '$' + (cents / 100).toFixed(2));
  const ROOMS = ['pantry', 'spice', 'bath', 'laundry', 'garage'];
  const ROOM_NAME = { pantry: 'Pantry', spice: 'Spice', bath: 'Bath', laundry: 'Laundry', garage: 'Garage', blank: 'Blank' };
  const CAP = { std: 14, sm: 30 };
  const MAXLEN = { std: 16, sm: 18 };
  const SIZE_NAME = { std: 'Standard, 2.47 × 0.85 in, 14 per sheet', sm: 'Small, 1.56 × 0.51 in, 30 per sheet' };
  const STYLE_NOTE = { modern: 'Black caps on white', noir: 'White caps on black', typewriter: 'Typed lowercase, warm white' };
  const PROP_CHUNK = 240;

  const parseWords = text => String(text || '').split(/\r?\n|,/).map(w => w.trim().toUpperCase()).filter(Boolean);
  const labelHTML = (word, style, size, fresh) =>
    `<div class="lab lab--${style} lab--${size}${fresh ? ' new' : ''}"><span>${esc(word)}</span></div>`;
  const styleKey = v => { const k = String(v || '').toLowerCase(); return k === 'noir' || k === 'typewriter' ? k : 'modern'; };
  const unique = arr => arr.filter((v, i) => v != null && arr.indexOf(v) === i);
  function addBusinessDays(from, n) {
    const d = new Date(from);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  const fmtDay = d => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  function init(el) {
    const cfgEl = el.querySelector('[data-studio-config]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { return; }
    const q = s => el.querySelector(s);
    const variants = cfg.variants || [];
    const optionNames = (cfg.options || []).map(o => String(o).toLowerCase());
    const styleIdx = optionNames.indexOf('style');
    const sizeIdx = optionNames.indexOf('size');
    const optOf = (v, idx) => (idx < 0 ? null : v.options[idx]);
    const styles = styleIdx >= 0 ? unique(variants.map(v => optOf(v, styleIdx))) : [];
    const sizes = sizeIdx >= 0 ? unique(variants.map(v => optOf(v, sizeIdx))) : [];
    const presets = {};
    ROOMS.forEach(r => { presets[r] = parseWords((cfg.words || {})[r]); });
    const threshold = Number(cfg.threshold) || 3;
    const bulkCents = Math.round(Number(cfg.bulkPrice || 0) * 100);

    const first = variants.find(v => v.available) || variants[0] || {};
    const st = {
      room: cfg.room || (presets.pantry.length ? 'pantry' : 'blank'),
      style: styleIdx >= 0 ? optOf(first, styleIdx) : null,
      size: sizeIdx >= 0 ? optOf(first, sizeIdx) : null,
      words: [],
      qty: 1
    };
    const sizeKey = () => {
      if (sizeIdx >= 0) return /small/i.test(st.size || '') ? 'sm' : 'std';
      return st.room === 'spice' ? 'sm' : 'std';
    };
    if (sizeIdx >= 0 && st.room === 'spice') st.size = sizes.find(s => /small/i.test(s)) || st.size;
    st.words = (presets[st.room] || []).slice(0, CAP[sizeKey()]);

    const variant = () => variants.find(v =>
      (styleIdx < 0 || optOf(v, styleIdx) === st.style) && (sizeIdx < 0 || optOf(v, sizeIdx) === st.size)) || first;
    const roomChoices = cfg.room ? [cfg.room, 'blank'] : ROOMS.concat('blank');

    function renderRooms() {
      q('[data-rooms]').innerHTML = roomChoices.map(r =>
        `<button class="opt" type="button" data-room="${r}" aria-pressed="${r === st.room}">${r === 'blank' ? 'Blank' : cfg.room ? `${ROOM_NAME[r]} starter list` : ROOM_NAME[r]}</button>`).join('');
      q('[data-room-note]').textContent = st.room === 'blank' ? 'A blank sheet' : `${(presets[st.room] || []).length} starter words`;
    }
    function renderStyles() {
      const wrap = q('[data-styles]');
      if (!styles.length) { wrap.closest('.step').hidden = true; return; }
      wrap.innerHTML = styles.map(s => {
        const k = styleKey(s);
        return `<button class="style-opt" type="button" data-style="${esc(s)}" aria-pressed="${s === st.style}"><span class="swatch">${labelHTML(k === 'typewriter' ? 'flour' : 'FLOUR', k, 'std')}</span><b>${esc(s)}</b><small>${STYLE_NOTE[k] || ''}</small></button>`;
      }).join('');
    }
    function renderSizes() {
      const wrap = q('[data-sizes]');
      const step = wrap.closest('.step');
      if (!sizes.length) { step.hidden = true; return; }
      step.hidden = false;
      wrap.innerHTML = sizes.map(s => `<button class="opt" type="button" data-size="${esc(s)}" aria-pressed="${s === st.size}">${esc(s)}</button>`).join('');
    }
    function renderWords() {
      const cap = CAP[sizeKey()];
      q('[data-words]').innerHTML = st.words.length
        ? st.words.map((w, i) => `<span class="wchip">${esc(w)}<button type="button" data-rm="${i}" aria-label="Remove ${esc(w)}">×</button></span>`).join('')
        : '<span class="empty-hint">No labels yet. Add your first one below.</span>';
      q('[data-count]').textContent = `${st.words.length} of ${cap} labels${st.words.length < cap ? ' · empty spots print blank' : ''}`;
      const input = q('[data-add-input]');
      input.disabled = st.words.length >= cap;
      input.placeholder = st.words.length >= cap ? 'Sheet is full. Remove one to add' : 'Add a label, or paste a list with commas';
      q('[data-size-note]').textContent = SIZE_NAME[sizeKey()];
    }
    function renderSheet(freshIndex) {
      const size = sizeKey(), cap = CAP[size], style = styleKey(st.style);
      const sheet = q('.studio__preview .sheet');
      sheet.className = `sheet sheet--${size}`;
      let cells = '';
      for (let i = 0; i < cap; i++) {
        cells += st.words[i] != null
          ? labelHTML(st.words[i], style, size, i === freshIndex && !reduced())
          : `<div class="lab-empty lab--${size}"><span>+</span></div>`;
      }
      sheet.innerHTML = cells;
      if (theme.fitLabels) theme.fitLabels(sheet);
      const preset = (presets[st.room] || []).slice(0, cap);
      const isPreset = st.room !== 'blank' && preset.length === st.words.length && preset.every((w, i) => w === st.words[i]);
      q('[data-caption]').textContent = `${isPreset ? ROOM_NAME[st.room] + ' starter list' : 'Your labels'} · ${st.style || 'Modern'}`;
    }
    function renderPrice() {
      const v = variant();
      const unit = v.price || 0;
      const each = st.qty >= threshold && bulkCents && bulkCents < unit ? bulkCents : unit;
      q('[data-price]').textContent = money(unit);
      q('[data-qty]').textContent = `${st.qty} sheet${st.qty === 1 ? '' : 's'}`;
      const btn = q('[data-add]');
      btn.disabled = !v.available;
      btn.textContent = v.available ? `Add to cart · ${money(each * st.qty)}` : 'Sold out';
      el.querySelectorAll('[data-tier]').forEach(t => t.classList.toggle('on', Number(t.dataset.tier) === (st.qty >= threshold ? threshold : 1)));
    }
    function render(freshIndex) {
      renderRooms();
      renderStyles();
      renderSizes();
      renderWords();
      renderSheet(freshIndex);
      renderPrice();
    }

    el.addEventListener('click', e => {
      const room = e.target.closest('[data-room]');
      if (room) {
        st.room = room.dataset.room;
        if (sizeIdx >= 0) st.size = st.room === 'spice' ? (sizes.find(s => /small/i.test(s)) || st.size) : (sizes.find(s => !/small/i.test(s)) || st.size);
        st.words = (presets[st.room] || []).slice(0, CAP[sizeKey()]);
        render();
        return;
      }
      const style = e.target.closest('[data-style]');
      if (style) { st.style = style.dataset.style; render(); return; }
      const size = e.target.closest('[data-size]');
      if (size) {
        st.size = size.dataset.size;
        const cap = CAP[sizeKey()];
        if (st.words.length > cap) {
          const cut = st.words.length - cap;
          st.words = st.words.slice(0, cap);
          if (theme.toast) theme.toast(`This size holds ${cap} labels: removed the last ${cut}`);
        }
        render();
        return;
      }
      const rm = e.target.closest('[data-rm]');
      if (rm) { st.words.splice(Number(rm.dataset.rm), 1); render(); return; }
      if (e.target.closest('[data-reset]')) { st.words = (presets[st.room] || []).slice(0, CAP[sizeKey()]); render(); return; }
      if (e.target.closest('[data-clear]')) { st.words = []; render(); q('[data-add-input]').focus(); return; }
      if (e.target.closest('[data-minus]')) { st.qty = Math.max(1, st.qty - 1); renderPrice(); return; }
      if (e.target.closest('[data-plus]')) { st.qty = Math.min(50, st.qty + 1); renderPrice(); return; }
      const addBtn = e.target.closest('[data-add]');
      if (addBtn) {
        if (!st.words.length) { if (theme.toast) theme.toast('Add at least one label first'); q('[data-add-input]').focus(); return; }
        const properties = {};
        let chunk = '', n = 1;
        st.words.forEach(w => {
          const next = chunk ? `${chunk} · ${w}` : w;
          if (next.length > PROP_CHUNK) { properties[n === 1 ? 'Labels' : `Labels (${n})`] = chunk; n++; chunk = w; }
          else chunk = next;
        });
        if (chunk) properties[n === 1 ? 'Labels' : `Labels (${n})`] = chunk;
        properties['Label count'] = `${st.words.length} of ${CAP[sizeKey()]}`;
        properties._studio = '1';
        addBtn.disabled = true;
        theme.cart.add([{ id: variant().id, quantity: st.qty, properties }], addBtn, `${cfg.productTitle} added`)
          .catch(() => {})
          .finally(() => { addBtn.disabled = false; });
      }
    });
    q('[data-add-form]').addEventListener('submit', e => {
      e.preventDefault();
      const input = q('[data-add-input]');
      const cap = CAP[sizeKey()];
      const max = MAXLEN[sizeKey()];
      const raw = input.value.split(/[,\n]/).map(v => v.trim().replace(/\s+/g, ' ').toUpperCase()).filter(Boolean);
      if (!raw.length) return;
      const long = raw.filter(v => v.length > max).length;
      const parts = raw.map(v => v.slice(0, max).trim());
      const room = cap - st.words.length;
      st.words.push(...parts.slice(0, room));
      input.value = '';
      render(st.words.length - 1);
      const notes = [];
      if (long) notes.push(`${long === 1 ? 'One label was' : long + ' labels were'} shortened to ${max} characters`);
      if (parts.length > room) notes.push(`sheet is full, ${parts.length - room} not added`);
      if (notes.length && theme.toast) theme.toast(notes.join('; ').replace(/^./, c => c.toUpperCase()));
      input.focus();
    });

    const eta = q('[data-eta]');
    if (eta) eta.textContent = `${fmtDay(addBusinessDays(new Date(), Number(cfg.etaMin) || 5))} – ${fmtDay(addBusinessDays(new Date(), Number(cfg.etaMax) || 10))}`;
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => theme.fitLabels && theme.fitLabels(el));
  }

  document.querySelectorAll('[data-studio]').forEach(init);
})();
